/**
 * detect is users is using iOS device
 *
 * Return: {boolean}
 *
 */
export const isiOS = () => {
  return navigator.platform.match(/iPhone|iPod|iPad/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 && !window.MSStream);
};

/**
 * detect if device has touch support
 *
 * @returns {boolean}
 */
const hasTouchSupport = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

/**
 * detect users device type mobile or desktop
 *
 * Return: {string} [mobile / desktop]
 *
 */
export const detectDevice = () => {
  return isiOS() || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || hasTouchSupport() ? 'mobile' : 'desktop';
};
